import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { useIntl } from 'react-intl'
import { FormikPhoneField, FormikTextField } from '../../../../../../../../components/FormikFields'

function AddUserEmployeeTab() {
  const intl = useIntl()

  return (
    <Row>
      <Col md="6">
        <FormikTextField
          id="department"
          title="FORM.DEPARTMENT"
          placeholder={intl.formatMessage({ id: 'PLACEHOLDER.ENTER_DEPARTMENT' })}
          required
          disablePasswordManager
        />
      </Col>
      <Col md="6">
        <FormikTextField
          id="jobTitle"
          title="FORM.JOB_TITLE"
          placeholder={intl.formatMessage({ id: 'PLACEHOLDER.ENTER_JOB_TITLE' })}
          required
          disablePasswordManager
        />
      </Col>
      <Col md="6">
        <FormikTextField
          id="firstName"
          title="FORM.NAME"
          placeholder={intl.formatMessage({ id: 'PLACEHOLDER.ENTER_FIRST_NAME' })}
          required
          disablePasswordManager
        />
      </Col>
      <Col md="6">
        <FormikTextField
          id="lastName"
          title="FORM.NAME"
          titleClassName="invisible"
          placeholder={intl.formatMessage({ id: 'PLACEHOLDER.ENTER_LAST_NAME' })}
          required
          disablePasswordManager
        />
      </Col>
      <Col md="6">
        <FormikPhoneField
          id="phone"
          title="FORM.PHONE"
          placeholder={intl.formatMessage({ id: 'PLACEHOLDER.ENTER_PHONE' })}
        />
      </Col>
    </Row>
  )
}

export default AddUserEmployeeTab
